export enum IExportFormat {
  CSV = 'csv',
  XML = 'xml',
  JSONL = 'jsonl',
  PARQUET = 'parquet',
}

export type ExportFormat =
  | IExportFormat.CSV
  | IExportFormat.XML
  | IExportFormat.JSONL
  | IExportFormat.PARQUET;
